export default "__VITE_ASSET__DPMNLIio__"